export const state = () => ({
    overview: null,
    funnel: [],
    breakdown: [],
    timeSeries: { labels: [], series: [] },
    /** New and active users per day — "who is coming". */
    users: { labels: [], series: [] },
    /** feature_open by feature — "what is used". */
    features: [],
    /** feature_locked by feature — where people hit the paywall. */
    locked: [],
    /** purchase_success by product — what is bought. */
    products: [],
    /** This calendar year, by month — feeds the yearly chart and the purchases card. */
    monthly: { labels: [], series: [] },
    paywalls: [],
    /** Visit length, time per screen, AI answer ratings, notification taps. */
    engagement: null,
    recent: [],
    /** Filters the log feed was last loaded with (devices, events, user…). */
    recentFilters: { devices: 'real' },
    /** The dashboard period ({ start_date, end_date }) the feed keeps to. */
    recentRange: {},
    recentLoading: false,
    recentHasMore: false,
    /** Log tab: rows per hour/day by group, the busiest people, themed side feeds. */
    logTimeline: { interval: 'hour', labels: [], series: [] },
    logTopUsers: [],
    logBreakdown: [],
    logPanels: {},
    logDevices: 'real',
    loading: false,
    error: null,
});
